import {globalStore} from "../../global.store";

export const roomStateTypes: { [key: string]: string } = {
    1: 'public',
    2: 'draft',
    3: 'private',
};

export const markerText: { [key: string]: string } = {
    live: 'LIVE EVENT',
    shop: 'SHOP',
    countdown: 'LIVE EVENT',
    private_event: 'PRIVATE EVENT',
    home: 'Home',
    private: 'Private',
    public: 'Public',
    draft: 'Draft',
};

export const userType = (userId: number, creatorId: number, admins: any, isCopiaRoom: boolean = false) => {
    if(isCopiaRoom) {
        return 'default'
    }
    if (globalStore.userData?.id == creatorId)
        return 'owner';
    else if (
        admins?.some((admin: any) =>
            typeof admin === 'number'
                ? admin == userId
                : admin.id == userId,
        )
    ) {
        return 'admin';
    }
    return 'default';
}
